//@flow
import Rollbar from 'rollbar'
import store from './state/store'
import { isProduction, getClientId } from './utils'

Rollbar.init({
  accessToken: '30f8159adc934105aa6e334e89126da1',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: isProduction() ? 'production' : 'development',
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.REACT_APP_GIT_SHA,
      },
    },
  },
  transform: payload => {
    // transforms filenames to match dummy `static.lln.training` domain for stacktraces
    const { trace } = payload.body
    const locRegex = /^(https?):\/\/[a-zA-Z0-9._-]+\.lln\.training(.*)/
    if (trace && trace.frames) {
      for (const frame of trace.frames) {
        const filename = frame.filename
        if (filename) {
          const match = filename.match(locRegex)
          if (match) {
            const [, protocol, path] = match
            frame.filename = protocol + '://static.lln.training/..' + path
          }
        }
      }
    }
  },
})

const clientId = getClientId()
Rollbar.configure({
  payload: {
    person: {
      clientId,
    },
  },
})

store.subscribe(() => {
  const { learner } = store.getState()
  if (!learner.loading && learner.email) {
    Rollbar.configure({
      payload: {
        person: {
          clientId,
          id: learner.id,
          email: learner.email,
          invite: learner.invite,
          currentQuestionId: learner.currentQuestionId,
        },
      },
    })
  }
})
if (/localhost/.test(window.location.hostname)) {
  Rollbar.configure({
    enabled: false,
  })
}



// WEBPACK FOOTER //
// ./src/rollbar.js